import React from "react";


const TituloComponent = ({ titulo }) => {
    return (
        <div className="card py-2 mt-2" style={{ background: "#6366f2" }}>
            <p className="text-center">
                <span className="font-bold text-4xl" style={{ color: "white", textTransform: "uppercase" }}>
                    {titulo}
                </span>
            </p>
        </div>
    );
}

export default TituloComponent;